import { render } from "./OrgTree.vue?vue&type=template&id=966d37d2&scoped=true"
import script from "./OrgTree.vue?vue&type=script&lang=js"
export * from "./OrgTree.vue?vue&type=script&lang=js"

import "./OrgTree.vue?vue&type=style&index=0&id=966d37d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-966d37d2"]])

export default __exports__